import { useEffect, useRef, useCallback } from 'react'

export const controlMap = {
  p1: { left: 'KeyA', right: 'KeyD', jump: 'KeyW', attack: 'KeyF', special: 'KeyG', dash: 'ShiftLeft' },
  p2: { left: 'ArrowLeft', right: 'ArrowRight', jump: 'ArrowUp', attack: 'Slash', special: 'Period', dash: 'ShiftRight' },
}

const handledKeyCodes = new Set([
  ...Object.values(controlMap.p1),
  ...Object.values(controlMap.p2),
])

export function useGameInput(isActive) {
  const pressed = useRef(new Set())
  const pressedOnce = useRef(new Set())

  const handleKeyDown = useCallback((e) => {
    if (!handledKeyCodes.has(e.code)) return
    if (!pressed.current.has(e.code)) {
      pressed.current.add(e.code)
      pressedOnce.current.add(e.code)
    }
  }, [])

  const handleKeyUp = useCallback((e) => {
    if (!handledKeyCodes.has(e.code)) return
    pressed.current.delete(e.code)
  }, [])

  useEffect(() => {
    if (!isActive) {
      pressed.current.clear()
      pressedOnce.current.clear()
      return
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keyup', handleKeyUp)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keyup', handleKeyUp)
    }
  }, [isActive, handleKeyDown, handleKeyUp])

  const consumePressedOnce = useCallback(() => {
    const snapshot = new Set(pressedOnce.current)
    pressedOnce.current.clear()
    return snapshot
  }, [])

  const isPressed = useCallback((keyCode) => pressed.current.has(keyCode), [])

  return { isPressed, consumePressedOnce }
}
